'use strict';

angular.module('cloudBillingLegacyFrontend').controller('ModalTeamEditUsersCtrl', function($scope, $modalInstance, $eaSession2, $controller, $eaBackend, $q, Users, IsCspTeam) {

  $.extend(self, $controller('TeamManagementCtrlMixin', {$scope: $scope, $eaBackend: $eaBackend, $q: $q}));

  $scope.existingUsers = Users;
  $scope.newUsers = [];
  $scope.removedUsers = [];

  $scope.newUser = {
    Contact: "",
    Role: IsCspTeam ? 'admin' : 'member',
    WildCardSubscriptions: true
  };

  $scope.isCspTeam = IsCspTeam;

  $scope.ok = function () {
    var userModel = {Name: null, Contact: $scope.newUser.Contact, Role: $scope.newUser.Role, Subscriptions: $scope.newUser.WildCardSubscriptions ? { '*': ['*'] } : {} };

    $modalInstance.close({newUsers: [userModel], removedUsers: []});
  };

  $scope.cancel = function () {
    $modalInstance.dismiss("cancel")
  };
});



